@if (visibleButtons().includes(floatingButtonsType.Groups)) {
  <div class="manage-groups">
    <button mat-button color="primary" class="manage-groups__button" (click)="navigateToGroups()">
      <mat-icon svgIcon="object-multi-group"></mat-icon>
      Manage Groups
    </button>
    @if (areMoreThanOneSelected() && showSelectionButtons()) {
      <button mat-button color="primary" class="manage-groups__button" (click)="createGroup.emit()">
        Create Group With Selection
      </button>
    }
    <button
      mat-fab
      color="primary"
      class="manage-groups__menu-button"
      [matMenuTriggerFor]="groupsMenu"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #groupsMenu="matMenu">
      <button mat-menu-item (click)="navigateToGroups()">
        <span>Manage Groups</span>
      </button>
      <button
        mat-menu-item
        [disabled]="!(areMoreThanOneSelected() && showSelectionButtons())"
        (click)="createGroup.emit()"
      >
        <span>Create Group With Selection</span>
      </button>
    </mat-menu>
  </div>
}
<div class="floating-mobile-actions-btn">
  @if (
    visibleButtons().includes(floatingButtonsType.Unsubscribe) &&
    isAtLeastOneSelected() &&
    showSelectionButtons()
  ) {
    <button
      mat-fab
      color="warn"
      matTooltip="Unsubscribe from all selected items"
      (click)="unsubscribeFromItems.emit()"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
  @if (
    visibleButtons().includes(floatingButtonsType.Delete) &&
    isAtLeastOneSelected() &&
    isOwnerOfAllSelectedItems() &&
    showSelectionButtons()
  ) {
    <button
      mat-fab
      color="warn"
      matTooltip="Delete all selected items"
      (click)="removeItems.emit()"
    >
      <mat-icon>delete</mat-icon>
    </button>
  }
  @if (visibleButtons().includes(floatingButtonsType.Create)) {
    <button mat-fab color="primary" matTooltip="Create new item" (click)="createItem.emit()">
      <mat-icon>add</mat-icon>
    </button>
  }
  @if (visibleButtons().includes(floatingButtonsType.Select)) {
    <button mat-fab color="primary" (click)="openSelection.emit()">
      <mat-icon>done</mat-icon>
    </button>
  }
  @if (visibleButtons().includes(floatingButtonsType.Filter)) {
    <button mat-fab color="primary" (click)="openFilters.emit()">
      <mat-icon>filter_alt</mat-icon>
    </button>
  }
</div>
